"use strict";

var _createForOfIteratorHelper = require("/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _slicedToArray = require("/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["", " && (", ")"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["{property: ", ",\n    missingProperty: ", ",\n    depsCount: ", ",\n    deps: ", "}"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["must have ", " ", " when property ", " is present"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateSchemaDeps = exports.validatePropertyDeps = exports.error = void 0;

var codegen_1 = require("../../compile/codegen");

var util_1 = require("../../compile/util");

var code_1 = require("../code");

exports.error = {
  message: function message(_ref) {
    var _ref$params = _ref.params,
        property = _ref$params.property,
        depsCount = _ref$params.depsCount,
        deps = _ref$params.deps;
    var property_ies = depsCount === 1 ? "property" : "properties";
    return codegen_1.str(_templateObject(), property_ies, deps, property);
  },
  params: function params(_ref2) {
    var _ref2$params = _ref2.params,
        property = _ref2$params.property,
        depsCount = _ref2$params.depsCount,
        deps = _ref2$params.deps,
        missingProperty = _ref2$params.missingProperty;
    return codegen_1._(_templateObject2(), property, missingProperty, depsCount, deps);
  } // TODO change to reference

};
var def = {
  keyword: "dependencies",
  type: "object",
  schemaType: "object",
  error: exports.error,
  code: function code(cxt) {
    var _splitDependencies = splitDependencies(cxt),
        _splitDependencies2 = _slicedToArray(_splitDependencies, 2),
        propDeps = _splitDependencies2[0],
        schDeps = _splitDependencies2[1];

    validatePropertyDeps(cxt, propDeps);
    validateSchemaDeps(cxt, schDeps);
  }
};

function splitDependencies(_ref3) {
  var schema = _ref3.schema;
  var propertyDeps = {};
  var schemaDeps = {};

  for (var key in schema) {
    if (key === "__proto__") continue;
    var deps = Array.isArray(schema[key]) ? propertyDeps : schemaDeps;
    deps[key] = schema[key];
  }

  return [propertyDeps, schemaDeps];
}

function validatePropertyDeps(cxt) {
  var propertyDeps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : cxt.schema;
  var gen = cxt.gen,
      data = cxt.data,
      it = cxt.it;
  if (Object.keys(propertyDeps).length === 0) return;
  var missing = gen.let("missing");

  var _loop = function _loop(prop) {
    var deps = propertyDeps[prop];
    if (deps.length === 0) return "continue";
    var hasProperty = code_1.propertyInData(gen, data, prop, it.opts.ownProperties);
    cxt.setParams({
      property: prop,
      depsCount: deps.length,
      deps: deps.join(", ")
    });

    if (it.allErrors) {
      gen.if(hasProperty, function () {
        var _iterator = _createForOfIteratorHelper(deps),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var depProp = _step.value;
            code_1.checkReportMissingProp(cxt, depProp);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    } else {
      gen.if(codegen_1._(_templateObject3(), hasProperty, code_1.checkMissingProp(cxt, deps, missing)));
      code_1.reportMissingProp(cxt, missing);
      gen.else();
    }
  };

  for (var prop in propertyDeps) {
    var _ret = _loop(prop);

    if (_ret === "continue") continue;
  }
}

exports.validatePropertyDeps = validatePropertyDeps;

function validateSchemaDeps(cxt) {
  var schemaDeps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : cxt.schema;
  var gen = cxt.gen,
      data = cxt.data,
      keyword = cxt.keyword,
      it = cxt.it;
  var valid = gen.name("valid");

  var _loop2 = function _loop2(prop) {
    if (util_1.alwaysValidSchema(it, schemaDeps[prop])) return "continue";
    gen.if(code_1.propertyInData(gen, data, prop, it.opts.ownProperties), function () {
      var schCxt = cxt.subschema({
        keyword: keyword,
        schemaProp: prop
      }, valid);
      cxt.mergeValidEvaluated(schCxt, valid);
    }, function () {
      return gen.var(valid, true);
    } // TODO var
    );
    cxt.ok(valid);
  };

  for (var prop in schemaDeps) {
    var _ret2 = _loop2(prop);

    if (_ret2 === "continue") continue;
  }
}

exports.validateSchemaDeps = validateSchemaDeps;
exports.default = def;